import {Action, ActionReducer, createReducer, MetaReducer, on} from '@ngrx/store';
import {
  creationAction,
  resetAction,
  set2FAAction,
  setActivateAssessorsAction,
  setAssessorsMailsAction,
  setAssessorsNamesAction,
  setChoicesAction, setConvocationDateAction, setConvocationTimeAction,
  setDescriptionAction,
  setDocumentAction,
  setDraftFlagAction,
  setEndDateAction,
  setEndTimeAction, setIgnoreAbstentionAction, setInviteDateAction, setInviteTimeAction,
  setLiveQuestionAction,
  setNewFileAction,
  setNumberOfVoteAction, setPhoneEditableAction,
  setPollImageAction,
  setPublicVoteAction, setQuorumAction,
  setResolutionsAction,
  setSecurityQuestionAction,
  setSenderAction,
  setSMSAction,
  setStartDateAction,
  setStartTimeAction,
  setTemporalityAction,
  setTitleAction,
  setVotersAction, setVotersImportDateAction,
  setVotingTypeAction,
  setWelcomeTextAction
} from './creationActions';
import {LiveQuestion, PollChoice, Resolution} from '../models/PollChoice';
import {Voter} from '../models/Voter';
export interface CreationState {
    poll: {
        draftSaved: boolean,
        temporality: string,
        votingType: string,
        title: string,
        description: string,
        sharedLinks: string,
        sender: string,
        startDate: string,
        startTime: string,
        endDate: string,
        endTime: string,
        voters: {
        },
        resolutions: Array<Resolution>,
        isUncrypted: boolean,
        isSMS: boolean,
        is2FA: boolean,
        isAssessors: boolean,
        assessorsNames: Array<string>,
        assessorsMails: Array<string>,
        liveQuestions: Array<LiveQuestion>,
        choices: Array<Array<PollChoice>>,
        imageId: string,
        securityQuestion: string,
        phoneEditable: boolean,
        voterImportDate: string,
        fileChanged: boolean,
        invalidPhoneVoters: Array<Voter>,
        welcomeText: string,
        quorum: number,
        inviteDate: string,
        inviteTime: string,
        convocationDate: string,
        convocationTime: string,
        ignoreAbstentions: boolean
    };
}

export const initialState: CreationState = {
    poll: {
      draftSaved: false,
      temporality: 'live',
      votingType: 'resolution',
      title: '',
      description: '',
      sharedLinks: '',
      sender: '',
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
      voters: [],
      resolutions: [],
      isUncrypted: false,
      isSMS: false,
      is2FA: false,
      isAssessors: false,
      assessorsNames: ['', '', ''],
      assessorsMails: ['', '', ''],
      liveQuestions: [],
      choices: [],
      imageId: '',
      securityQuestion: null,
      phoneEditable: false,
      voterImportDate: undefined,
      fileChanged: false,
      invalidPhoneVoters: [],
      welcomeText: null,
      quorum: null,
      inviteDate: null,
      inviteTime: null,
      convocationDate: null,
      convocationTime: null,
      ignoreAbstentions: false
    }
};

function creationLog(reducer: ActionReducer<CreationState, Action>): ActionReducer<CreationState, Action> {
    return (state, action) => {
      return reducer(state, action);
    };

}

export const metaReducer: MetaReducer = creationLog;

export const creationReducer = createReducer(initialState,
    on(creationAction, (state) => {
        return  {
            ...state
        };
    }),
    on(resetAction, () => initialState),
    on(setVotingTypeAction, (state, props) => {
        if (props.votingType === 'resolution') {
            return {
                ...state,
                poll: {
                    ...state.poll,
                    votingType: props.votingType,
                    isAssessors: false
                }
            };
        } else {
            return {
                ...state,
                poll: {
                    ...state.poll,
                    votingType: props.votingType
                }
            };
        }
    }),
    on(setSecurityQuestionAction, (state, props) => {
      return {
        ...state,
        poll: {
          ...state.poll,
          securityQuestion: props.securityQuestion,
        }
      };
    }),
    on(setPhoneEditableAction, (state, props) => {
      return {
        ...state,
        poll: {
          ...state.poll,
          phoneChangeable: props.phoneChangeable
        }
      };
    }),
    on(setTitleAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                title: props.title
            }
        };
    }),
    on(setDescriptionAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                description: props.description
            }
        };
    }),
    on(setDocumentAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                sharedLinks: props.sharedLinks
            }
        };
    }),
    on(setSenderAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                sender: props.sender
            }
        };
    }),
    on(setPollImageAction, (state, props) => {
      return {
        ...state,
        poll: {
          ...state.poll,
          imageId: props.imageId
        }
      };
    }),
    on(setPublicVoteAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                isUncrypted: props.isUncrypted
            }
        };
    }),
    on(setSMSAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                isSMS: props.isSMS
            }
        };
    }),
    on(set2FAAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                is2FA: props.is2FA,
                isSMS: false
            }
        };
    }),
    on(setTemporalityAction, (state, { temporality }) => ({
        ...state,
        poll: {
            ...state.poll,
            temporality,
        },
    })),
    // on(setTemporalityAction, (state, props) => {
    //     return {
    //         ...state,
    //         poll: {
    //             ...state.poll,
    //             draftSaved: false,
    //             temporality: props.temporality,
    //         }
    //     }
    // }),
    on(setStartDateAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                startDate: props.startDate,
            }
        };
    }),
    on(setStartTimeAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                startTime: props.startTime,
            }
        };
    }),
    on(setEndDateAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                endDate: props.endDate,
            }
        };
    }),
    on(setEndTimeAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                endTime: props.endTime,
            }
        };
    }),
    on(setInviteDateAction, (state, props) => {
      return {
        ...state,
        poll: {
          ...state.poll,
          inviteDate: props.inviteDate
        }
      };
    }),
    on(setInviteTimeAction, (state, props) => {
      return {
        ...state,
        poll: {
          ...state.poll,
          inviteTime: props.inviteTime
        }
      };
    }),
    on(setConvocationTimeAction, (state, props) => {
      return {
        ...state,
        poll: {
          ...state.poll,
          convocationTime: props.convocationTime
        }
      };
    }),
    on(setConvocationDateAction, (state, props) => {
      return {
        ...state,
        poll: {
          ...state.poll,
          convocationDate: props.convocationDate
        }
      };
    }),
    on(setVotersAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                    voters: props.voters,
            }
        };
    }),
    on(setActivateAssessorsAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                    isAssessors: props.isAssessors,
            }
        };
    }),
    on(setAssessorsNamesAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                    assessorsNames: props.assessorsNames,
            }
        };
    }),
    on(setAssessorsMailsAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                    assessorsMails: props.assessorsMails,
            }
        };
    }),
    on(setLiveQuestionAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                liveQuestions: props.liveQuestions
            }
        };
    }),
    on(setResolutionsAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                resolutions: props.resolutions,
            }
        };
    }),
    on(setChoicesAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                choices: props.choices,
            }
        };
    }),
    on(setNumberOfVoteAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                liveQuestions: {
                    ...state.poll.liveQuestions,
                    numberOfVote: props.numberOfVote,
                }
            }
        };
    }),
    on(setDraftFlagAction, (state, props) => {
        return {
            ...state,
            poll: {
                ...state.poll,
                    draftSaved: props.draftSaved,
            }
        };
    }),
    on(setVotersImportDateAction, (state, props) => {
      return {
        ...state,
        poll: {
          ...state.poll,
            voterImportDate: props.voterImportDate
        }
      };
    }),
    on(setNewFileAction, (state, props) => {
      return {
        ...state,
        poll: {
          ...state.poll,
          file: props.fileChanged
        }
      };
    }),
    on(setWelcomeTextAction, (state, props) => {
        return {
            ...state,
            poll: {
              ...state.poll,
              welcomeText: props.welcomeText
            }
        };
    }),
    on(setQuorumAction, (state, props) => {
      const quorumAdjusted = props.quorum <= 100 ? props.quorum : 50;
      return {
        ...state,
        poll: {
          ...state.poll,
          quorum: quorumAdjusted
        }
      };
    }),
    on(setIgnoreAbstentionAction, (state, props) => {
      return {
        ...state,
        poll: {
          ...state.poll,
          ignoreAbstentions: props.ignorable
        }
      };
    })
    );
